<template>
  <ul class="balance-sidebar">
    <!-- <li @click="toggleSideSubMenu('cashoutRequest')">
      <div class="nominal-balance">
        <div class="flex justify-between">
          <p><b>Нийт хөрөнгө</b></p>
          <div class="eye-container">
            <div class="eye-icon"></div>
          </div>
        </div>
        <div class="flex balance mnt">
          <h2><b>787878784</b></h2>
          <p>MNT<p/>
        </div>
        <div class="flex">
          <p>7878787878</p><p>USD</p>
        </div>
      </div>
    </li> -->
    <template v-for="(item, i) in items">
      <router-link
        v-if="item.to"
        :to="item.to"
        class="sidebar-item"
        :class="{ active: $route.path === item.to }"
        :key="`sidebar${i}`"
      >
        <div class="flex align-center sidebar-link">
          <i :class="item.icon" v-if="item.icon !== 'sr sr-moneybag'"></i>
          <!-- moneybag add icon байхгүй тул зургаар оруулахаас өөр аргагүй -->
          <img
            class="icon"
            v-else
            :src="
              dark
                ? '/img/user/common/sr-moneybag-add-light.svg'
                : '/img/user/common/sr-moneybag-add.svg'
            "
            alt=""
          />
          <p class="btn-txt text-body-sm">{{ item.text }}</p>
        </div>
      </router-link>
      <div
        v-else
        class="sidebar-item"
        :class="{ expanded: expanded === i }"
        :key="`sidebarelse${i}`"
        @click="expand(i)"
      >
        <div class="flex align-center sidebar-link">
          <i :class="item.icon"></i>
          <p class="btn-txt text-body-sm">{{ item.text }}</p>
        </div>
        <div class="sidebar-subitem-wrapper">
          <div
            v-show="expanded === i"
            class="sidebar-subitem"
            :class="{ active: $route.path === sub.to }"
            v-for="(sub, j) in item.items"
            :key="`sub${j}`"
            :to="sub.to"
            @click.stop="$router.push(sub.to)"
          >
            <i :class="sub.icon" class="sidebar-submenu-icon"></i>
            <p>{{ sub.text }}</p>
          </div>
        </div>
      </div>
    </template>
  </ul>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import OrderTrHistory from './OrderTrHistory'
import CashOutRequest from './CashOutRequest'
import NewsList from './NewsList'

export default {
  components: {
    'cash-out-request': CashOutRequest,
    'order-trade-history': OrderTrHistory,
    'news-list': NewsList,
  },
  data() {
    return {
      menuType: null,
      expanded: null,
    }
  },
  methods: {
    ...mapActions('common', ['toggleSbState']),
    toggleSideSubMenu(menuType) {
      if (!this.menuType) {
        this.toggleSbState()
        this.menuType = menuType
      } else if (this.menuType === menuType) {
        this.toggleSbState()
        this.menuType = null
      } else {
        this.menuType = menuType
      }
    },
    expand(i) {
      if (this.expanded === i) {
        this.expanded = null
      } else {
        this.expanded = i
      }
    },
    checkRoute() {
      this.items.forEach((item, i) => {
        if (item.to === this.$route.path) {
          this.expanded = i
        }
      })
      this.items.forEach((item, i) => {
        if (item.to === null) {
          item.items.forEach((sub) => {
            if (sub.to === this.$route.path) {
              this.expanded = i
            }
          })
        }
      })
    },
    showKycToast() {
      if (this.kycToast){
        this.$bvToast.toast(
            'Бүртгэлээ бүрэн бөглөнө үү.',
            {title: 'Мэдэгдэл', variant: 'danger'},
        )
        this.$store.dispatch('common/hideKycToast', false)
      }
    },
    showPaymentToast() {
      if (this.paymentToast){
        this.$bvToast.toast(
            'Эрхэм харилцагч Та дансны хураамж 10,000 төгрөгийг төлнө үү.',
            {title: 'Мэдэгдэл', variant: 'danger'},
        )
        this.$store.dispatch('common/hidePaymentToast', false)
      }
    }
  },
  computed: {
    ...mapState('brand', ['brand', 'stockType']),
    ...mapState('common', ['sbState', 'dark', 'kycToast', 'paymentToast']),
    isNotIpo() {
      return this.stockType != '1'
    },
    items() {
      return [
        {
          text: this.$t('user.profile'),
          icon: 'sr sr-user',
          to: '/user/kyc',
        },
        {
          text: this.$t('user.agreement'),
          icon: 'sr sr-document-clipped-v2',
          to: '/user/document',
        },
        {
          text: this.$t('cashout.account-type'),
          icon: 'sr sr-wallet',
          to: '/user/trade/balance',
        },
        {
          text: this.$t('user.yield'),
          icon: 'sr sr-axis-linegraphs-average-up',
          to: '/user/return',
        },
        {
          text: this.$t('sidebar.history'),
          icon: 'sr sr-clock-progress',
          to: null,
          items: [
            {
              text: this.$t('account.statement'),
              icon: 'sr sr-document',
              to: '/user/nominal-transaction',
            },
            {
              text: this.$t('pagelayout.mse-transaction'),
              icon: 'sr sr-document',
              to: '/user/mse-transaction',
            },
            {
              text: this.$t('sidebar.order'),
              icon: 'sr sr-document-envelope',
              to: '/user/trade/order-history',
            },
            {
              text: this.$t('trade.history'),
              icon: 'sr sr-moneybook',
              to: '/user/trade/trade-history',
            },
          ],
        },
        {
          text: this.$t('account.notification'),
          icon: 'sr sr-newspaper',
          to: '/user/notification',
        }
      ]
    },
  },
  watch: {
    '$route.path'() {
      this.checkRoute()
    },
    kycToast() {
      this.showKycToast()
    },
    paymentToast() {
      this.showPaymentToast()
    },
  },
  created() {
    this.checkRoute()
    this.showKycToast()
    this.showPaymentToast()
  },
}
</script>

<style lang="scss">
@import '../../../sass/common_mixin';
.balance-sidebar {
  list-style-type: none;
  margin: 0;
  padding: 0;
  .nominal-balance {
    margin: 2rem;
    background-color: var(--alt-child-card-bg-color);
    border-radius: 1rem;
    padding: 1.5rem;
  }
  .eye-container {
    height: 26px;
    width: 26px;
    background-color: RGBA(var(--rgb-dark-background-color), 0.1);
    border-radius: 0.5rem;
    .eye-icon {
      height: inherit;
      width: inherit;
      background: var(--text-primary-color);
      mask-image: url('../../assets/images/line.png');
      -webkit-mask-image: url('../../assets/images/line.png');
      mask-repeat: no-repeat;
      mask-position: center;
      mask-mode: alpha;
    }
  }
  .balance {
    .mnt > p {
      color: rgb(var(--text-grey-color));
    }
  }

  .sidebar-subitem-wrapper {
    display: flex;
    flex-direction: column;

    .sidebar-subitem {
      padding: 15px 30px;

      &:hover {
        background-color: var(--landing-apps-background);
        text-decoration: none;
      }

      p {
        padding-left: calc(22px + 20px);
      }
    }
  }

  .sidebar-item,
  .sidebar-item .sidebar-subitem {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    text-decoration: none;

    .flex {
      padding: 15px 30px;
      &:hover {
        background-color: var(--landing-apps-background);
        text-decoration: none;
      }
    }

    i {
      font-size: 22px;
      color: var(--text-primary-color);
      margin-right: 20px;
    }

    img {
      width: 22px;
      height: 22px;
      margin-right: 20px;
    }

    p {
      color: var(--text-primary-color-alpha-5);
      @include text-title-5;
      margin: 0;
    }

    &.active {
      background-color: var(--landing-apps-background);

      p {
        color: var(--text-primary-color);
      }
    }
  }
  .flex {
    display: flex;
  }
  .align-center {
    align-items: center;
  }
  .justify-between {
    justify-content: space-between;
  }
  .justify-around {
    justify-content: space-around;
  }
}
</style>
